import { FormikErrors } from "formik"
import { AudioFormat, Language } from "../../../../typings/types"
import { BatchItem } from "../BatchItem"
import { InitialErrors } from "../validation/interfaces"
import { FormErrorFields } from "../validation/interfaces"
import { Fields } from "./reducer"

export enum ActionTypes {
    ADVANCE_STEPPER,
    REVERSE_STEPPER,
    SET_ITEMS,
    UPDATE_ITEM,
    UPDATE_LANGUAGES,
    UPDATE_SELECTOR,
    UPDATE_AUDIO_FORMATS,
    UPDATE_SOURCE_LANGUAGE,
    UPDATE_TARGET_LANGUAGE,
    RESET,
    ALLOW_STEP_ACTION,
    PREVENT_STEP_ACTION,
    SET_ORIGINAL_FILENAME,
    UPDATE_FIRST_TRANSLATE,
    SET_OPERATION_ERRORS,
    SET_INITIAL_ERRORS
}

interface SetItemsAction {
    type: ActionTypes.SET_ITEMS
    items: BatchItem[]
}

export const setItems = (items: BatchItem[]): SetItemsAction => ({
    type: ActionTypes.SET_ITEMS,
    items: items
})

interface UpdateAvailableLanguagesAction {
    type: ActionTypes.UPDATE_LANGUAGES
    value: Language[]
}

export const updateAvailableLanguages = (value: Language[]): UpdateAvailableLanguagesAction => ({
    type: ActionTypes.UPDATE_LANGUAGES,
    value: value
})

interface UpdateItemAction {
    type: ActionTypes.UPDATE_ITEM
    index: number
    value: Partial<BatchItem>
}

export const updateItem = (index: number, value: Partial<BatchItem>): UpdateItemAction => ({
    type: ActionTypes.UPDATE_ITEM,
    index: index,
    value: value
})

interface UpdateSelectAction {
    id: Fields
    type: ActionTypes.UPDATE_SELECTOR
    value: string
}

export const updateSelect = (field: Fields, value: string): UpdateSelectAction => ({
    id: field,
    type: ActionTypes.UPDATE_SELECTOR,
    value: value
})

interface UpdateAvailableAudioFormatsAction {
    type: ActionTypes.UPDATE_AUDIO_FORMATS
    value: AudioFormat[]
}

export const updateAvailableAudioFormats = (
    value: AudioFormat[]
): UpdateAvailableAudioFormatsAction => ({
    type: ActionTypes.UPDATE_AUDIO_FORMATS,
    value: value
})

interface UpdateSourceLanguageAction {
    type: ActionTypes.UPDATE_SOURCE_LANGUAGE
    value: number
}

export const updateSourceLanguage = (value: string): UpdateSourceLanguageAction => ({
    value: parseInt(value),
    type: ActionTypes.UPDATE_SOURCE_LANGUAGE
})

interface UpdateTargetLanguageAction {
    type: ActionTypes.UPDATE_TARGET_LANGUAGE
    value: number
}

export const updateTargetLanguage = (value: string): UpdateTargetLanguageAction => ({
    type: ActionTypes.UPDATE_TARGET_LANGUAGE,
    value: parseInt(value)
})

interface ResetAction {
    type: ActionTypes.RESET
}

export const reset = (): ResetAction => ({
    type: ActionTypes.RESET
})

interface UpdateFirstTranslateAction {
    type: ActionTypes.UPDATE_FIRST_TRANSLATE
    value: boolean
}

export const updateFirstTranslate = (value: boolean): UpdateFirstTranslateAction => ({
    type: ActionTypes.UPDATE_FIRST_TRANSLATE,
    value: value
})

interface SetOriginalFilenameAction {
    type: ActionTypes.SET_ORIGINAL_FILENAME
    value: string
}

export const setOriginalFilename = (value: string): SetOriginalFilenameAction => ({
    type: ActionTypes.SET_ORIGINAL_FILENAME,
    value: value
})

interface SetOperationErrorsAction {
    type: ActionTypes.SET_OPERATION_ERRORS
    itemIndex: number
    errors: FormikErrors<FormErrorFields>
}

export const setOperationErrors = (
    itemIndex: number,
    errors: FormikErrors<FormErrorFields>
): SetOperationErrorsAction => ({
    type: ActionTypes.SET_OPERATION_ERRORS,
    itemIndex,
    errors
})

interface SetInitialErrorsAction {
    type: ActionTypes.SET_INITIAL_ERRORS
    value: InitialErrors
}

export const setInitialErrors = (value: InitialErrors): SetInitialErrorsAction => ({
    type: ActionTypes.SET_INITIAL_ERRORS,
    value
})

export type Action =
    | SetItemsAction
    | UpdateAvailableLanguagesAction
    | UpdateItemAction
    | UpdateSelectAction
    | UpdateAvailableAudioFormatsAction
    | UpdateSourceLanguageAction
    | UpdateTargetLanguageAction
    | ResetAction
    | SetOriginalFilenameAction
    | UpdateFirstTranslateAction
    | SetOperationErrorsAction
    | SetInitialErrorsAction
